import React, { useState } from 'react';
import { IonIcon } from '@ionic/react';
import { checkmarkOutline, copyOutline } from 'ionicons/icons';
import type { ChatMessage } from '../../../application/use-cases/ai/useAiConversation';
import AiMarkdown from './AiMarkdown';
import AiReasoning from './AiReasoning';
import { useSmoothText } from './useSmoothText';

const CopyButton: React.FC<{ text: string }> = ({ text }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      // Sin permiso de portapapeles (o navegador viejo): no hay nada que hacer.
    }
  };
  return (
    <button type="button" className="ai-msg-action" onClick={copy} aria-label={copied ? 'Copiado' : 'Copiar respuesta'}>
      <IonIcon icon={copied ? checkmarkOutline : copyOutline} />
      <span>{copied ? 'Copiado' : 'Copiar'}</span>
    </button>
  );
};

const AssistantMessage: React.FC<{ message: ChatMessage; animate: boolean }> = ({ message, animate }) => {
  const streaming = message.status === 'streaming';
  const { text, caughtUp } = useSmoothText(message.content, animate);
  const typing = streaming || !caughtUp;

  return (
    <div className="ai-msg-assistant">
      <AiReasoning text={message.reasoning} ms={message.reasoningMs} thinking={streaming && !message.content} />
      {text && (
        <div className={`ai-markdown${typing ? ' is-typing' : ''}`}>
          <AiMarkdown text={text} streaming={typing} />
        </div>
      )}
      {message.status === 'stopped' && !typing && <p className="ai-msg-note">Respuesta detenida</p>}
      {!typing && message.content && (
        <div className="ai-msg-actions">
          <CopyButton text={message.content} />
        </div>
      )}
    </div>
  );
};

const AiMessageBubble: React.FC<{ message: ChatMessage; animate: boolean }> = ({ message, animate }) => {
  if (message.role === 'assistant') return <AssistantMessage message={message} animate={animate} />;
  return (
    <div className={`ai-bubble ai-bubble-user${message.status === 'failed' ? ' is-failed' : ''}`}>
      {message.content}
    </div>
  );
};

export default AiMessageBubble;
